import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Catalog from "@/components/Catalog";
import OrderForm from "@/components/OrderForm";
import Policies from "@/components/Policies";
import About from "@/components/About";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

export default function Home() {
  return (
    <div className="min-h-screen bg-paper">
      <Navbar />
      <Hero />
      <Marquee />
      <Catalog />
      <OrderForm />
      <Policies />
      <About />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
